var StoreAttributeModel = require('../../app/models/store-attribute');

var StaticData = function() {
  this.init();
};

StaticData.prototype = {
  init: function() {
    this.storeAttributes = new Backbone.Collection(bookedby.staticData.storeAttributes, { model: StoreAttributeModel });

    this.storeAttributeMap = {};

    this.storeAttributes.each(_.bind(function(storeAttribute) {
      this.storeAttributeMap[storeAttribute.get('id')] = storeAttribute;
    }, this));
  }
};


module.exports = StaticData;